export default function Checkbox(theme) {
	return {
		MuiCheckbox: {
			defaultProps: {},
			styleOverrides: {}
		}
	};
}
